import React from 'react';
import { Navbar } from '../features/navigation/components/Navbar';
import { AddBrand } from '../features/admin/components/AddBrand';

export const AddBrandPage = () => {
  return (
    <>
      <Navbar />
      <AddBrand />
    </>
  );
};
